import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { hideNotification, showNotification } from '@mantine/notifications';
import { Stack, Group, TextInput, Loader } from '@mantine/core';
import CustomRichTextEditor from '../../../../components/CustomRichTextEditor';
import Autoload from '../../../../neoverv/Autoload';
import DisplayModalForMobileView from '../../../../neoverv/components/Module/General/CustomModal/DisplayModalForMobileView';

var Setting = Autoload.Setting;
var lang = Setting[Setting.language_default];

export class TilesForTenantPortal extends Component {
  state = {
    value: null,
    noSaveDuringImageUpload: false,
    allImagesData: [],
    openDisplayModalForMobileView: false,
    headingForMobileModal: null,
    contentForMobileModal: null,
    firstOnChange: false
  };

  constructor(props) {
    super(props);
    this.typingTimeout = null; 
    this.editorRef = createRef();
  }

  componentDidMount() {
    const { body, allImagesData } = this.props;
    if (body) {
      this.setState({ allImagesData });
    }
  }

  componentDidUpdate(prevProps) {
    const { allImagesData } = this.props;
    if (prevProps.allImagesData !== allImagesData) {
      this.setState({ allImagesData });
    }
  }

  // Tiptap onChange only passes the HTML string
  handleChange = (value) => {
    // Pass the raw HTML string provided by Tiptap directly
    this.props.updateHtml(value);

    // Debounce logic remains exactly the same
    if (this.typingTimeout) {
      clearTimeout(this.typingTimeout);
    }
    this.typingTimeout = setTimeout(this.handleUserStoppedTyping, 2000);
  };

  handleUserStoppedTyping = () => {
    this.props.updateHtml(this.props.body, true);
    this.typingTimeout = null;
  };

  handleImageUpload = async (file) =>
    new Promise((resolve, reject) => {
      const { propertySelected, id } = this.props;
      const { allImagesData } = this.state;
      
      this.setState({ noSaveDuringImageUpload: true });
      
      const formData = new FormData();
      formData.append('file', file);
      formData.append('accountId', propertySelected.accountId);
      formData.append('propertyId', propertySelected.id);
      formData.append('name', file.name);
      formData.append('isDirectory', false);
      formData.append('isReadOnly', false);
      formData.append('isShared', false);
      formData.append('fileType', 'NoteDocument');
      formData.append('referencedObjectId', id);

      fetch(Autoload.Setting.document_api_base_url + 'documents', {
        method: 'POST',
        body: formData,
        headers: {
          Authorization: Autoload.Utils.getAuthToken()
        }
      })
        .then((data) => data.json())
        .then((response) =>
          fetch(Autoload.Setting.document_api_base_url + 'documents/' + response?.result?.id, {
            method: 'GET',
            headers: {
              'Authorization': Autoload.Utils.getAuthToken()
            }
          })
            .then(data2 => {
              data2.json().then(response2 => {
                this.setState({
                  allImagesData: [
                    ...allImagesData,
                    {
                      id: response2?.result?.id,
                      fileLocation: response2?.result?.fileLocation
                    }
                  ],
                  noSaveDuringImageUpload: false
                }, () => 
                  // RESOLVE BOTH URL AND ID
                  resolve({
                    url: response2?.result?.fileLocation,
                    id: response2?.result?.id
                  })
                );
              })
            }).catch(() => reject(new Error('Download failed')))
        )
        .catch(() => reject(new Error('Upload failed')));
    });

  renderRTE = () => {
    const { body, title, updateTitle } = this.props;
    return (
      <Stack>
        <TextInput
          label={'Titel'}
          value={title}
          styles={{
            label: { fontSize: '12px', fontWeight: 400, color: '#727293' }
          }}
          onChange={(e) => updateTitle(e.target.value)}
          onBlur={() => updateTitle(title, true)}
        />
        <Stack gap={0}>
          <span className='rich-text-editor-box-label'>Inhalte</span>
          <CustomRichTextEditor
            value={body}
            onChange={this.handleChange} 
            onImageUpload={this.handleImageUpload} // Pass the upload method down
            className={'rich-text-editor-box-editor'}
            enableImage={true}
          />
        </Stack>
      </Stack>
    );
  };

  setMobileViewStates = (openDisplayModalForMobileView, contentForMobileModal, headingForMobileModal) => {
    this.setState({ openDisplayModalForMobileView, contentForMobileModal, headingForMobileModal });
  }

  render() {
    const { title, body, displayOrder, loader, dragStart, isMobile } = this.props;
    const { openDisplayModalForMobileView, headingForMobileModal, contentForMobileModal } = this.state;

    return (
      <Stack gap={10} style={{ width: '100%' }}>
        {loader ? (
          <Group justify='center' align={'center'}>
            <Loader />
          </Group>
        ) : !dragStart ? (
          isMobile ? (
            <Stack>
              {title &&
                <Stack gap={0}>
                  <span className='rich-text-editor-box-label'>Titel</span>
                  <span onClick={() => this.setMobileViewStates(true, this.renderRTE(), 'Aushänge')}>{title}</span>
                </Stack>}
              <Stack gap={0}>
                <span className='rich-text-editor-box-label'>Inhalte</span>
                <div className='mobile-notes-content' dangerouslySetInnerHTML={{ __html: body }} onClick={() => this.setMobileViewStates(true, this.renderRTE(), 'Aushänge')} />
              </Stack>
            </Stack>
          ) : (
            this.renderRTE()
          )
        ) : (
          <Group justify='center' align={'center'} style={{ height: '100%' }}>
            <span style={{ fontWeight: 'bolder', fontSize: '20px', opacity: 0.5 }}>{displayOrder}</span>
          </Group>
        )}

        {openDisplayModalForMobileView &&
          <DisplayModalForMobileView
            open={openDisplayModalForMobileView}
            toggle={() => this.setMobileViewStates(false, null, null)}
            heading={headingForMobileModal}
            content={contentForMobileModal}
            className={'display-modal-for-mobile-view'}
          />}
      </Stack>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    propertySelected: state.generalReducer.property,
  };
};
export default connect(mapStateToProps)(TilesForTenantPortal);